export default __webpack_public_path__ + "static/media/reimbursement-logo.15413a10.svg";